import { render, staticRenderFns } from "./agogis-class-lookup.vue?vue&type=template&id=98215ce0"
import script from "./agogis-class-lookup.vue?vue&type=script&lang=ts"
export * from "./agogis-class-lookup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports